export default __webpack_public_path__ + "static/stadiem-logo-11654936bb18af6fccc004bcf2bde727.svg";